<kuv-loading></kuv-loading>
<kuv-alert></kuv-alert>

<div class="container-fluid p-2 p-sm-5">
    <h2>Servicios</h2>
    <button class="btn btn-primary my-3" (click)="add()"><i class="fas fa-plus-circle me-2"></i>Agregar Servicio</button>
    <kuv-lazy-table [url]="config.apiUrl + 'servicio/index'" [filtros]="filtros" [columnas]="columnas" [acciones]="acciones" [reloadEmitter]="reloadEmitter" [hasShadow]="true" [headers]="sesion.headers" [filtros]="filtros" [isRounded]="true"></kuv-lazy-table>
</div>